import {
  airplane,
  boat,
  bus,
  car,
  train,
  tracks,
  layover,
} from "../icons/Transportation";
import { DefaultIcon, clock, idea } from "../icons/General";
import { hotel } from "../icons/Accommodation";
import { walk, shopping, hammock } from "../icons/Activity";

export const IconMap = {
  airplane: airplane,
  boat: boat,
  bus: bus,
  car: car,
  train: train,
  layover: layover,
  //tracks
  tracks: tracks,
  clock: clock,
  idea: idea,
  //accommodation
  hotel: hotel,
  condo: hotel,
  airbnb: hotel,
  //activity
  walking: walk,
  hiking: walk,
  shopping: shopping,
  lounging: hammock,
  boating: boat,
  default: DefaultIcon,
};
